const pageMeta = require('../lib/page');

!function (window) {
  var namespace = window._ns_bbcws = window._ns_bbcws || "s_bbcws";
  var sources = window[namespace].sources;

  /* Data object for loaded media. */
  function avTracker(trackerId, data) {
    if (!window.s_bbcws_ATInternet) {
      require('../../vendor/ati/syndtag-av');
    }

    data = data || {};

    this.trackerId = trackerId;
    this.clipId = data.clipId;
    this.clipName = data.clipName;
    this.clipDuration = (data.live !== true) ? data.clipDuration : 0;
    this.mediaType = data.mediaType;
    this.player = data.player || undefined;
    this.section = data.section || undefined;
    this.live = (data.live === true);

    this.playStarted = false;

    // this.subSection = data.subSection || undefined;
    // this.subSubSection = data.subSubSection || undefined;

    // this.loadEventTriggered = false;

    var tag = new s_bbcws_ATInternet.Tracker.Tag();
    this.atiMedia = new tag.avInsights.Media(5, 5);

    this.atiMedia.set('library_version', window[namespace]._getVersion());
    this.atiMedia.set('page_title', pageMeta.getTitle());
    this.atiMedia.set('url', pageMeta.getUrl());

    if (pageMeta.getReferrer()) {
      this.atiMedia.set('referrer_url', pageMeta.getReferrer());
    }

    this.atiMedia.set('partner_id', window[namespace]._data.find('partner'));

    var producerName = window[namespace]._getProducer();
    if (producerName && window[namespace]._producerExists(producerName)) {
      var producer = window[namespace]._enums.ati.producers[producerName];
      this.atiMedia.set('site_level2', producer.name || producerName.charAt(0).toUpperCase() + producerName.slice(1));
    }

    if (this.clipName) {
      this.atiMedia.set('av_content', this.clipName);
    }

    this.atiMedia.set('av_content_id', 'pnr_' + String(this.clipId));

    if (this.mediaType && getMediaTypeName(this.mediaType)) {
      this.atiMedia.set('av_content_type', getMediaTypeName(this.mediaType));
    }

    if (this.clipDuration) {
      this.setDuration(this.clipDuration);
    }
  }

  function getMediaTypeName(mediaType) {
    var allowed = ['audio', 'video']
    var index = allowed.indexOf(mediaType.toLowerCase());

    if (index >= 0) {
      var type = allowed[index];
      return type.charAt(0).toUpperCase() + type.slice(1);
    }
  }

  avTracker.prototype.setDuration = function (durationSeconds) {
    this.clipDuration = durationSeconds;
    this.atiMedia.set('av_content_duration', durationSeconds.toFixed(3) * 1000);
  }

  avTracker.prototype.isValid = function () {
    return (this.trackerId != undefined &&
           this.clipId != undefined &&
           this.clipName != undefined &&
           ((!this.live && this.clipDuration > 0) ||
           (this.live && this.clipDuration == 0)) 
           // && this.getComscoreMediaTypeCode() != undefined // TODO add logic to confirm "IF audio or video"
         );
  }

  /* Define/register functions into core tracker. */
  function fetchTracker(tracker) {
    if (typeof tracker != 'object') {
      tracker = window[namespace].getAvTracker(tracker);
    }

    if (tracker == undefined) {
      throw "Tracker does not exist.";
    }

    if (!tracker.isValid()) {
      throw "Tracker is invalid or missing required data.";
    }

    return tracker;
  }

  window[namespace]._registerTrackEvent('avLoad', function (tracker, duration) {
      if (duration > 0 && tracker.live !== true) {
        tracker.setDuration(duration);
      }
  });

  window[namespace]._registerTrackEvent('avPlay', function (tracker, offset, callback) {
    if (fetchTracker(tracker).playStarted === true) {
      fetchTracker(tracker).atiMedia.playbackResumed(offset*1000);
    } else {
      fetchTracker(tracker).atiMedia.play(offset*1000);
      fetchTracker(tracker).atiMedia.playbackStart(offset*1000);
      fetchTracker(tracker).playStarted = true;
    }
  });

  window[namespace]._registerTrackEvent('avPause', function (tracker, offset) {
    if (offset < fetchTracker(tracker).clipDuration) {
      fetchTracker(tracker).atiMedia.playbackPaused(offset*1000);
    }
  });
  
  window[namespace]._registerTrackEvent('avEnd', function (tracker) {
    var tracker = fetchTracker(tracker);
    var duration = tracker.clipDuration;

    tracker.atiMedia.playbackStopped(duration.toFixed(3) * 1000);
    fetchTracker(tracker).playStarted = false;
  });

   // window[namespace]._registerTrackEvent('avPlay', function (tracker, offset, callback) {
  //   /* Temporary AV tracking workaround */
  //   var callback = callback || function () {};
    
  //   if (!this._hasTrackEvent('pageView')) {
  //     var script = document.createElement('script'),
  //         scriptUrl = this._baseUrl + "/js/pageTracker.min.js",
  //         scripts = document.getElementsByTagName('script')[0];
      
  //     script.onload = function () {
  //       s_bbcws('track','pageView');
  //       callback();
  //     }
  //     script.src = scriptUrl;
      
  //     scripts.parentNode.insertBefore(script, scripts);
  //     window[namespace].sources.push(scriptUrl);
  //   } else {
  //     if (this._trackLog.indexOf('pageView') < 0) {
  //       s_bbcws('track','pageView');
  //     }
  //     callback();
  //   }
  // }); 

  window[namespace]._trackers = window[namespace]._trackers || {};
  window[namespace].createAvTracker = function (trackerId, data, suppressLoadEvent) {
    if (!trackerId) {
      throw 'No tracker identity passed.'
    } else if (this._trackers[trackerId]) {
      throw 'Tracker with identity already exists.';
    }

    this._trackers[trackerId] = new avTracker(trackerId, data);

    if (true !== suppressLoadEvent) {
      this.track('avLoad', this._trackers[trackerId]);
    }

    return this._trackers[trackerId];
  }

  window[namespace].getAvTracker = function (trackerId) {
    return this._trackers[trackerId];
  }

  window[namespace].hasAvTracker = function (trackerId) {
    return trackerId in this._trackers;
  }

  window[namespace].trackHtml5AV = function (trackerId, data, avElement) {
    data.mediaType = avElement.localName;

    var tracker = this.createAvTracker(trackerId, data, true);

    if (avElement.readyState && avElement.readyState > 0) {
      window[namespace].track('avLoad', tracker, avElement.duration);
    } else {
      avElement.addEventListener("loadedmetadata", function (event) {
  			window[namespace].track('avLoad', tracker, event.target.duration);
  		});
    }

    avElement.addEventListener("play", function (event) {
			window[namespace].track('avPlay', tracker, event.target.currentTime.toFixed(3));
		});

    avElement.addEventListener("pause", function (event) {
			window[namespace].track('avPause', tracker, event.target.currentTime.toFixed(3));
		});

    avElement.addEventListener("ended", function (event) {
      window[namespace].track('avEnd', tracker);
    });

    return tracker;
  }
}(window);
